import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "containers/general/title"
import { loadingStatus } from "actions"
import _ from "lodash"
import LotModal from "containers/modals/lot"
import moment from "moment"
import numeral from "numeral"
import FullTable from "components/FullTable"
import settings from "settings"
import helpers from "helpers/helpers"
import Modal from "react-responsive-modal"
//import MassUpdater from "containers/admin/MassUpdater"
import * as FileSaver from "file-saver"
import { toast } from "react-toastify"
import submitData from "helpers/submitData"

class LotManagement extends Component {
	constructor(props) {
		super(props)
		let cols = [
			{
				Header: "Lot ID",
				accessor: "Lot ID",
				show: true,
				width: 60,
				filterMethod: (f, r) => helpers.tableText(f, r, "Lot ID"),
			},
			{
				Header: "Dev",
				accessor: "Development Code",
				show: true,
				width: 60,
				filterMethod: (f, r) => helpers.tableText(f, r, "Development Code"),
			},
			{
				Header: "Community",
				accessor: "Community",
				show: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
			},
			{
				Header: "Sub",
				accessor: "Subdivision Name",
				show: true,
				width: 60,
				filterMethod: (f, r) => helpers.tableText(f, r, "Subdivision Name"),
			},
			{
				Header: "Neighborhood",
				accessor: "Neighborhood",
				show: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "Neighborhood"),
			},
			{
				Header: "Type",
				accessor: "Lot Type",
				show: true,
				width: 60,
				filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
			},
			{
				Header: "Lot",
				accessor: "Lot",
				show: true,
				width: 50,
				filterMethod: (f, r) => helpers.tableText(f, r, "Lot"),
			},
			{
				Header: "Block",
				accessor: "Block",
				show: true,
				width: 60,
				filterMethod: (f, r) => helpers.tableText(f, r, "Block"),
			},
			{
				Header: settings?.renames?.section || "Section",
				accessor: "Section Name",
				show: true,
				width: 70,
				filterMethod: (f, r) => helpers.tableText(f, r, "Section Name"),
			},
			{
				Header: "Builder",
				accessor: "Builder",
				show: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
			},
			{
				Header: "Address",
				accessor: "Address",
				show: true,
				//filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				filterMethod: (f, r) => {
					if (r.Address?.props?.children?.toLowerCase().includes(f.value.toLowerCase())) {
						return true
					}
				},
				sortMethod: (a, b) => {
					try {
						let aVal = a.props.children
						let bVal = b.props.children
						// Extract street numbers for comparison
						let aStreetNum = parseInt(aVal.match(/^\d+/) || [0], 10)
						let bStreetNum = parseInt(bVal.match(/^\d+/) || [0], 10)

						// Compare street numbers numerically
						if (aStreetNum !== bStreetNum) {
							return aStreetNum - bStreetNum
						}

						// If street numbers are the same, compare the full string
						return aVal.localeCompare(bVal)
					} catch (e) {
						console.log(e)
					}
				},
			},
			{
				Header: "In Feed",
				accessor: "In Feed",
				show: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "In Feed"),
			},
			{
				Header: "Floorplan",
				accessor: "Floorplan",
				show: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "Floorplan"),
			},
			{
				Header: "Buyer Last",
				accessor: "Primary Last",
				show: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "Primary Last"),
			},
			...(settings?.enabled?.lotManagement?.showBasePrice
				? [{ Header: "Base Price", accessor: "Base Price", show: true }]
				: []),
			...(settings?.enabled?.lotManagement?.showPremium
				? [{ Header: "Premium", accessor: "Premium", show: true }]
				: []),
			...(settings?.enabled?.lotManagement?.hideTakedownPrice
				? []
				: [
						{
							Header: "TD Price",
							accessor: "Takedown Price",
							show: true,
						},
				  ]),
			{
				Header: "TD Date",
				accessor: "Takedown Date",
				show: true,
				Cell: (v) => {
					if (v.value) {
						return moment.unix(v.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Construction Status",
				show: true,
				accessor: "Construction Status",
				filterMethod: (f, r) => helpers.tableText(f, r, "Construction Status"),
			},
			{
				Header: "Buyer Status",
				accessor: "Sale Status",
				show: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "Sale Status"),
			},
			{
				Header: "Contract Date",
				accessor: "Sale Date",
				show: true,
				Cell: (v) => {
					if (v.value) {
						return moment.unix(v.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Close Date",
				accessor: "Closing Date",
				show: true,
				Cell: (v) => {
					if (v.value) {
						return moment.unix(v.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Sale Price",
				accessor: "Sale Price",
				show: true,
			},
			{
				Header: "Neighborhood Id",
				accessor: "Neighborhood Id",
				show: false,
				disableFilter: true,
			},
			{
				Header: "Section Id",
				accessor: "Section Id",
				show: false,
				disableFilter: true,
			},
			{
				Header: "View",
				accessor: "view",
				show: true,
				width: 60,
			},
		]
		let addl = settings?.additionalLotManagementColumns
		if (addl) {
			let len = cols.length
			for (let v of addl) {
				if (v.colType == "date") {
					v.filterMethod = (f, r) => helpers.dateFilter(f, r)
				} else if (v.colType == "text") {
					v.filterMethod = (f, r) => helpers.tableText(f, r, v.accessor)
				}

				cols.splice(len - 1, 0, v)
			}
		}
		this.state = {
			columns: cols,
			open: false,
			openMassUpdater: false,
			data: this.buildTable(),
			excelHide: ["section_id", "view", "completion", "site_id"],
			updateRows: [],
		}
		this.tableState = React.createRef()
	}

	componentDidMount() {
		if (parseInt(this.props.match.params.id)) {
			let lot = _.find(this.props.payload.exec.lots, { id: parseInt(this.props.match.params.id) })
			if (lot) {
				this.setState({ data: lot, open: true })
			}
		}
	}

	componentDidUpdate(prevProps) {
		// Check if the ID parameter has changed
		if (prevProps.match.params.id !== this.props.match.params.id) {
			if (parseInt(this.props.match.params.id)) {
				let lot = _.find(this.props.payload.exec.lots, { id: parseInt(this.props.match.params.id) })
				if (lot) {
					this.setState({ data: lot, open: true })
				}
			} else {
				// If the ID is removed or becomes falsy, close the modal
				this.setState({ open: false })
			}
		}
	}

	closeModal = () => {
		this.setState({
			open: false,
		})
	}

	openModal = (v, r) => {
		delete r.view
		let f = { ...r, ...v }
		this.setState({ data: f, open: true })
	}

	buildTable = () => {
		let data = []
		_.forEach(this.props.payload.exec.lots, (v, k) => {
			let r = {
				address: (
					<a className="underline" onClick={() => this.openModal(v, r)}>
						{v.address}
					</a>
				),
				builder: v.builder_name,
				lot: v.lot,
				block: v.block,
				section: v.section_name,
				primary_last: v.primary_last,
				takedown_date: v.takedown_date,
				closing_date: v.closing_date,
				sale_date: v.sale_date,
				estimated_closing: v.estimated_closing,
				community: v.property_name,
				completionDate: v.completion ? moment.unix(v.completion).format("MM/DD/YY") : "",
				price_partic_fee: numeral(v.price_partic_fee).format("$0,0.00"),
				fence_fee: numeral(v.fence_fee).format("$0,0.00"),
				base_price: numeral(v.base_price).format("$0,0.00"),
				premium: numeral(v.premium).format("$0,0.00"),
				marketing_price: v.marketing_price,
				in_feed: v.in_feed ? "Yes" : "No",
			}
			r = { ...v, ...r }
			if (v.model == 1) {
				r.sale_status = "Model"
			} else if (v.closing_date) {
				r.sale_status = "Closed"
			} else if (!v.closing_date && v.sale_id) {
				r.sale_status = "Contract"
			} else if (v.lot_status == "Bustout") {
				r.sale_status = "Bustout"
			} else if (v.reserve_start_date && !v.sale_id) {
				r.sale_status = "Reserved"
			} else {
				r.sale_status = ""
			}

			if (!v.takedown_date) {
				r.const_status = ""
			} else if (v.complete_date) {
				r.const_status = "Complete"
			} else if (v.landscaped_date) {
				r.const_status = "Landscaped"
			} else if (v.masonry_date) {
				r.const_status = "Masonry"
			} else if (v.roofed_date) {
				r.const_status = "Roofed"
			} else if (v.framed_date) {
				r.const_status = "Framed"
			} else if (v.start_date) {
				r.const_status = "Slab"
			} else {
				r.const_status = "Vacant"
			}
			let sale = _.find(this.props.payload.exec.sales, { id: v.sale_id })
			if (sale) {
				r.closing_price = sale.closing_price
			}
			let dev = _.find(this.props.payload.public.developers, { id: v.developer })
			if (dev) {
				r.dev = dev.code
			}
			try {
				r.site = ""
				_.forEach(v.site_id, (row) => {
					let site = _.find(this.props.payload.public.sites, { id: row })
					if (site) {
						r.site += site.name + ", "
					}
				})
				r.site = r.site.trim().replace(/,$/, "")
			} catch (error) {
				console.log(error)
			}
			let isd = _.find(this.props.payload.public.isds, { id: v.isd })
			if (isd) {
				r.isd = isd.code
			}
			let lid = _.find(this.props.payload.public.lids, { id: v.lid })
			if (lid) {
				r.lid = lid.name
			}
			let mud = _.find(this.props.payload.public.muds, { id: v.mud })
			if (mud) {
				r.mud = mud.name
			}
			let sub = _.find(this.props.payload.public.subdivisions, { id: v.subdivision })
			if (sub) {
				r.sub_code = sub.code
			}
			try {
				let lot_premium_type = _.find(this.props.payload.public?.options?.lot_premium_types, {
					id: v.lot_premium_type,
				})
				if (lot_premium_type) {
					r.lot_premium_type = lot_premium_type.name
				}
			} catch (e) {
				console.log(e)
			}
			r.view = (
				<a onClick={() => this.openModal(v, r)}>
					<i className="far fa-edit"></i>
				</a>
			)
			let f = {
				Community: r.community,
				"Neighborhood Id": v.neighborhood,
				"Section Id": v.section_id,
				"Lot ID": r.id,
				"Development Code": r.dev,
				"Subdivision Code": r.sub_code,
				"Subdivision Name": r.subdivision_name,
				Neighborhood: r.neighborhood_name,
				"Section Name": r.section_name,
				"Substantial Completion Date": r.completionDate,
				Lot: r.lot,
				Block: r.block,
				Model: r.model,
				"Lot Type": r.lot_type_name,
				"Site Type": r.site,
				ISD: r.isd,
				LID: r.lid,
				MUD: r.mud,
				"In Feed": r.in_feed,
				Builder: r.builder_name,
				Address: r.address,
				"Takedown Date": r.takedown_date,
				"Takedown Price": r.takedown_price ? numeral(r.takedown_price).format("$0,0.00") : "$0.00",
				"Base Price": r.base_price,
				Premium: r.premium,
				...(r?.lot_premium_type ? { "Lot Premium Type": r.lot_premium_type } : {}),
				"Fence Fee": r.fence_fee,
				"Marketing Fee": r.fee_marketing ? numeral(r.fee_marketing).format("$0,0.00") : "$0.00",
				"Permit Number": r.permit_number,
				"Permit Issued": r.permit_issued ? moment.unix(r.permit_issued).format("MM/DD/YY") : "",
				"Permit Final": r.permit_final ? moment.unix(r.permit_final).format("MM/DD/YY") : "",
				"Construction Status": r.const_status,
				"Start Date": r.start_date,
				"Complete Date": r.complete_date,
				"Sale Status": r.sale_status,
				"Sale Date": r.sale_date,
				"Estimated Closing": r.estimated_closing,
				"Sale Price": r.sale_price ? numeral(r.sale_price).format("$0,0.00") : "",
				"Closing Date": r.closing_date,
				"Closing Price": r.closing_price ? numeral(r.closing_price).format("$0,0.00") : "",
				Acreage: r.acreage,
				"Sale ID": r.sale_id,
				"Buyer ID": r.buyer_id,
				"Primary Last": r.primary_last,
				Latitude: r.latitude,
				Longitude: r.longitude,
				Floorplan: r.floorplan_name,
				"Home Square Feet": r.sqft ? numeral(r.sqft).format("0,0") : "",
				Beds: r.beds,
				Garage: r.garage,
				"Full Baths": r.full_baths,
				"Half Baths": r.half_baths,
				"Price Partication Percent": r.price_partic_percent,
				"Price Participation Fee": r.price_partic_fee,
				"Date HUD Closing": r.date_hud_closing,
				"Recordation Number": r.recordation_num,
				"Salesperson First": r.salesperson_first,
				"Salesperson Last": r.salesperson_last,
				"Marketing Price": r.marketing_price ? numeral(r.marketing_price).format("$0,0.00") : "$0.00",
				view: r.view,
			} // ordered
			if (r.addl) f.addl = r.addl
			data.push(f)
		})
		return data
	}

	outputTotalUpdateRows = () => {
		if (this.state.updateRows.length) {
			return <p className="text-xs">Number of Rows: {this.state.updateRows.length}</p>
		}
		return ""
	}

	excelClean = (data) => {
		let ret = []
		_.forEach(data, (v, ind) => {
			_.forEach(v._original, (r, k) => {
				if (r && typeof r === "object" && k !== "addl") {
					data[ind]._original[k] = r.props?.children
				}
			})
			ret.push(v)
		})
		return ret
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="lotManagement">
					<Title title="Lot Management" showDate={false} />
					<div className="content">
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="lotManagement__master"
							unset={["view"]}
							title="LotManagement"
							excelClean={this.excelClean}
							classNames={"small"}
							pageSize={25}
							onTableStateChange={(tableState) => {
								this.tableState.current = tableState
							}}
						/>
						<div className="flex justify-end pb-3">
							{/* <div
								className="btn text-xs"
								onClick={() => {
									this.setState({ openMassUpdater: true })
								}}>
								Mass Update Rows
							</div> */}
							<div className="border-dashed border border-blue p-2 bg-neutral-100 w-1/2">
								<div className="flex justify-between">
									<p>Mass Update Templating</p>
									{this.outputTotalUpdateRows()}
								</div>
								<p className="my-0 text-xs">
									<i className={`pr-2 fas fa-info-circle`} />
									To build a mass lot update template, filter the rows you want added, then click "Add
									Rows to Output". You can hit this button multiple times to add more rows to the
									output. When completed, click "Build Template" to download. Once filled out, the
									template can be dropped into Mass Lot Update tool.
								</p>
								<div className="flex mt-2">
									<div
										className="btn text-xs mr-2"
										onClick={() => {
											try {
												let rows = this.tableState.current.getResolvedState().sortedData
												rows = _.map(rows, (v) => v._original["Lot ID"])
												let cur = _.clone(this.state.updateRows)
												let ret = _.union(cur, rows)
												this.setState({ updateRows: ret })
											} catch (e) {
												console.log(e)
											}
										}}>
										Add Rows to Output
									</div>
									<div
										className="btn text-xs mr-2"
										onClick={() => {
											this.setState({ updateRows: [] })
										}}>
										Clear Stored Rows
									</div>
									<div
										className="btn text-xs"
										onClick={() => {
											if (this.state.updateRows.length === 0) {
												toast.error(`No rows selected for template.`)
												return
											}
											this.props.loadingStatus(true)
											submitData("generateTemplateOnIds", {
												rows: this.state.updateRows,
											})
												.then((data) => {
													this.props.loadingStatus(false)
													if (data.status == 200) {
														toast.success(data.message)
														let csv = data.csv.replace(/\\n/g, "\n")
														FileSaver.saveAs(
															new Blob([csv], { type: "text/csv;charset=utf-8" }),
															"lot-update-template.csv"
														)
														this.setState({ generatorErrorText: false })
													} else {
														toast.error(data.message)
														this.setState({ generatorErrorText: data.message })
													}
												})
												.catch((e) => {
													toast.error(e.message)
													this.setState({ generatorErrorText: e.message })
												})

											this.props.loadingStatus(false)
										}}>
										Build Template
									</div>
								</div>
							</div>
						</div>
						<LotModal open={this.state.open} data={this.state.data} onClose={this.closeModal} />
						{/* <Modal
							open={this.state.openMassUpdater}
							onClose={() => {
								this.setState({ openMassUpdater: false })
							}}
							center
							classNames={{ modal: "w-11/12 max-w-none" }}>
							<MassUpdater
								// Pass filtered rows if available, otherwise pass all rows
								rows={this.tableState.current}
							/>
						</Modal> */}
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ loadingStatus }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(LotManagement)
